import axios from "axios";

const TOKEN_KEY = "setplay_session_token";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor: add Bearer token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || "";
      const isAuthCheck = url.includes("/auth/me");

      if (!isAuthCheck) {
        // App auth failed — redirect to login
        localStorage.removeItem(TOKEN_KEY);
        const currentPath = window.location.pathname;
        if (currentPath !== "/login" && currentPath !== "/") {
          window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export function setSessionToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function clearSessionToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export default api;
